
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import Loading from "../../components/loading.vue";
import ResultTs from "./ts/result-ai";
import CandidateAnswerSection from "./components/candidate-answer-section-h5.vue";
import SvgImg from "@/components/videoPaly/index.vue";
import AudioStyle from "@/components/videoPaly/audioStyle.vue";
import AiGuide from "./guide-h5.vue";
import EnglishProficiency from "./components/english/index.vue";
import Mandarin from "@/views/paper/components/mandarin/mandarin.vue";
import eyeColorH5 from "./components/eye-color-h5.vue";
import SingleDimensionMindRes from "@/components/single-dimension-mind-res.vue";
import DvfResV2 from "@/views/paper/components/dvf-res-v2.vue";
import Login from "@/views/paper/paper-result-report/login.vue"; //提取码登录
import { Report } from "@/lib/model/exam/candidate";
import { createWatermark, removeWatermark } from "@/utils/watermark";

@Component({
  components: {
    DvfResV2,
    Loading,
    SvgImg,
    AudioStyle,
    CandidateAnswerSection,
    AiGuide,
    EnglishProficiency,
    Mandarin,
    eyeColorH5,
    SingleDimensionMindRes,
    Login
  }
})
export default class PaperResultNew extends ResultTs {
  @Prop({ type: Boolean, default: false }) hideTool!: boolean;
  @Prop({ default: "" }) btnColor!: string;

  fixedTab = false;
  pdetail = true;
  scrollId = "";
  scrolling = false;
  showMoreImg = true;
  showError = false;
  allParamIsShow = false;
  hasExpandOther = [
    "eyeColor",
    "finger",
    "replacePerson",
    "webJump",
    "faceDetection"
  ];
  lastPlayVideoIndex = -1; // 最后播放的视频序号
  hasTabScroll = false;
  isAndroid = false;
  showFix = false;

  showCopyToast = false; // 复制报告链接提示
  timer = 0;
  count = 0;
  toastCountDown() {
    const TIME_COUNT = 2;
    if (!this.timer) {
      this.count = TIME_COUNT;
      this.timer = setInterval(() => {
        if (this.count > 1 && this.count <= TIME_COUNT) {
          //限制倒计时区间
          this.count--;
        } else {
          clearInterval(this.timer); //删除定时器
          this.timer = 0;
          this.showCopyToast = false;
        }
      }, 1000);
    }
  }
  get showGroupStar() {
    return this.all.reportShowConfig.hiddenDimensionGroupStar !== 1;
  }

  //是否折叠图片
  get showMoreBtn() {
    return (
      this.candidate.replaceCheckResult.imgList.length > 3 && !this.showMoreImg
    );
  }

  // 展示填空题的参考答案
  get showReferenceAnswer() {
    return this.all.configGroup.showReferenceAnswer === 1;
  }

  //展示出的图片
  get getImgList() {
    if (this.showMoreBtn) {
      return this.candidate.replaceCheckResult.imgList.slice(0, 3);
    } else {
      return this.candidate.replaceCheckResult.imgList;
    }
  }

  // 维度组下是否隐藏了面试总览下的全部内容
  get groupHideAllOverview() {
    return (
      !this.Show("hiddenOverviewDimensionGroupIcon") &&
      !(this.Show("hiddenOverviewAiComment") && this.all.aiComment.aiComment) &&
      !(this.Show("hiddenOverviewHrComment") && this.candidate.auditDesc) &&
      !(
        this.Show("hiddenOverviewNextSuggest") && this.all.aiComment.nextSuggest
      )
    );
  }

  get extraH5List() {
    return this.all.extraResultList.map((el: any) => {
      this.$set(el, "isShow", false);
      return el;
    });
  }

  // 面试总览是否显示
  get isShowOverview() {
    return (
      this.Show("hiddenOverview") &&
      (this.isGroup
        ? !this.groupHideAllOverview
        : this.Show("hiddenOverviewPieChart"))
    );
    // &&
    // (!(
    //   (!this.isGroup && this.Show("hiddenOverviewPieChart")) ||
    //   (this.isGroup && this.Show("hiddenOverviewDimensionGroupIcon"))
    // ) ||
    //   !(
    //     (this.Show("hiddenOverviewAiComment") &&
    //       this.all.aiComment.aiComment) ||
    //     (this.Show("hiddenOverviewHrComment") && this.candidate.auditDesc) ||
    //     (this.Show("hiddenOverviewNextSuggest") &&
    //       this.all.aiComment.nextSuggest)
    //   ))
  }

  created() {
    //
  }
  // 缓存提取码对应的面试id
  reportCertiCodeCacheExamId = 0;
  // 是否需要提取码
  async needPassword(retryCount = 0): Promise<boolean | undefined> {
    try {
      const res = await Report.getInfo({
        connectCode: this.connectCode,
        tid: this.$route.query.tid as string
      });
      this.reportCertiCodeCacheExamId = res.reportCertiCodeCacheExamId;
      return res.needReportCertiCode;
    } catch (e) {
      console.error(e);
      // 可以根据重试次数决定是否再次调用
      if (retryCount < 3) {
        // 假设最多重试3次
        return this.needPassword(retryCount + 1);
      } else {
        // 达到最大重试次数后
        this.$message.error("网络不佳，请稍后重试吧");
      }
    }
  }

  showLogin = false;
  login() {
    this.showLogin = false;
    this.loadPage();
  }

  async checkPwd() {
    const needPwd = await this.needPassword(); //此处不封try catch，网络不通就需要停在这里
    if (needPwd) {
      //先判缓存的提取码是否正确
      const pass = await (this.$refs as any).login.checkLocalstroage();
      //不正确则展示提取码页面
      if (!pass) {
        this.showLogin = true;
      }
      return pass;
    }
    return true; //不需要提取码
  }
  async mounted() {
    this.connectCode = this.$route.query.connectCode as string;
    this.isStudent = String(this.$route.query.ver || "") === "1";
    //是否需要输入提取码
    const pass = await this.checkPwd();
    if (!pass) return;
    this.loadPage();
  }

  loadPage() {
    this.open();
    this.getSystem();
    setTimeout(() => {
      this.getTabScroll();
    }, 1000);
    this.dom = document.getElementById("full") as HTMLElement;
    setTimeout(() => {
      window.addEventListener("scroll", this.handleScrollCard);
      // 添加水印
      this.createWatermark();
    }, 1000);
  }

  getSystem() {
    const system = navigator.userAgent.toLowerCase();
    if (/(Android|Adr)/i.test(system)) {
      this.isAndroid = true;
    }
  }

  getTabScroll() {
    const tab = document.getElementById("normaltab") as HTMLElement;
    // const tab = (this.$refs as any).normaltab

    setTimeout(() => {
      if (tab) {
        if (tab.scrollWidth > tab.clientWidth) {
          this.hasTabScroll = true;
        } else {
          this.hasTabScroll = false;
        }
      }
    }, 500);
  }

  expandError() {
    this.showError = !this.showError;
  }
  selectCard(e: any) {
    const id = e.srcElement.id;
    const el: any = window.document.getElementById("scroll" + id);
    if (el) {
      this.scrolling = true;
      this.$nextTick(() => {
        setTimeout(() => {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
        }, 400);
        setTimeout(() => {
          this.scrolling = false;
          this.scrollId = id;
        }, 1000);
      });
    }
  }
  //判断某个原生DOM元素是否不在屏幕可见区内
  isElementNotInViewport(el: HTMLElement) {
    const rect = el?.getBoundingClientRect();
    return (
      // rect?.top >=
      //   (window.innerHeight || document.documentElement.clientHeight) ||
      rect?.bottom <= 0
    );
  }
  lastTopMove = 0;
  dom = {} as HTMLElement;
  // 滑动卡片
  public handleScrollCard(event: any) {
    // console.log(event);
    const rect = this.dom.getBoundingClientRect();
    this.showFix = rect.y > this.lastTopMove ? true : false;
    this.showScrollTop();
    this.lastTopMove = rect.y;

    //fix tabs
    if (
      this.isElementNotInViewport(this.$refs.switchTabAnchor as HTMLElement)
    ) {
      this.fixedTab = true;
      setTimeout(() => {
        const fixtab = (this.$refs as any).fixtab as HTMLElement;
        if (fixtab) {
          if (fixtab.scrollWidth > fixtab.clientWidth) {
            this.hasTabScroll = true;
          } else {
            this.hasTabScroll = false;
          }
        }
      }, 1000);
    } else {
      this.fixedTab = false;
    }
    if (this.scrolling) return;
    //active tab
    ["d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8"].forEach(item => {
      const el: any = window.document.getElementById("scroll" + item);

      if (
        el &&
        !this.isElementNotInViewport(el) &&
        el.getBoundingClientRect().top < 50
      ) {
        this.scrollId = item;
      }
    });
  }

  @Emit("show-scroll-top")
  showScrollTop() {
    return this.showFix;
  }

  handleShowShare() {
    this.showShare = !this.showShare;
  }

  // 创建水印
  createWatermark() {
    // 检查路由参数watermark，如果为空则不生成水印
    const watermarkParam = this.$route.query.watermark || "";
    if (!watermarkParam) {
      return;
    }

    // 移除现有水印
    this.removeWatermark();

    // 检查目标容器是否存在
    const targetContainer = document.querySelector(".mainBox");

    if (!targetContainer) {
      console.error("🔍 H5水印调试 - 未找到.mainBox容器");
      return;
    }

    const watermarkConfig = {
      text: watermarkParam,
      containerSelector: ".mainBox",
      width: 230,
      height: 200,
      color: "#f0f1f2",
      fontSize: 14,
      rotate: -30,
      opacity: 0.5,
      zIndex: 450
    };

    const result = createWatermark(watermarkConfig);
  }

  // 移除水印
  removeWatermark() {
    removeWatermark(".mainBox");
  }
}
